import { render, staticRenderFns } from "./fl44-unknown-volume-proposal-show.vue?vue&type=template&id=ed488abe&scoped=true&"
import script from "./fl44-unknown-volume-proposal-show.vue?vue&type=script&lang=js&"
export * from "./fl44-unknown-volume-proposal-show.vue?vue&type=script&lang=js&"
import style0 from "./fl44-unknown-volume-proposal-show.vue?vue&type=style&index=0&id=ed488abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed488abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed488abe')) {
      api.createRecord('ed488abe', component.options)
    } else {
      api.reload('ed488abe', component.options)
    }
    module.hot.accept("./fl44-unknown-volume-proposal-show.vue?vue&type=template&id=ed488abe&scoped=true&", function () {
      api.rerender('ed488abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/proposals/fl44-unknown-volume-proposal-show.vue"
export default component.exports